export default __webpack_public_path__ + "static/media/specialties.3b8d668b.png";